import { render } from "./Centre.vue?vue&type=template&id=0469fa7a"
import script from "./Centre.vue?vue&type=script&lang=js"
export * from "./Centre.vue?vue&type=script&lang=js"

import exportComponent from "F:\\-=Projects=-\\Sites\\map\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__